"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidUrl;
function isValidUrl(stringToCheck) {
  var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
  return regex.test(stringToCheck);
}